import { Component, ViewChild, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonDialogData } from 'src/app/models/CommonDialogData';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { NgForm } from '@angular/forms';
//import { CustomerAccountBusinessLogicService } from 'src/app/services/customer-account-business-logic.service';
import * as Constants from '../../../models/Constants';

@Component({
  selector: 'app-tba-domain-selection',
  templateUrl: './tba-domain-selection.component.html',
  styleUrls: ['./tba-domain-selection.component.scss']
})
export class TbaDomainSelectionComponent implements OnInit {
  @ViewChild('domainSelecterForm') domainSelecterForm!: NgForm;
  selectedDomain: string = '';
  leftNavData: any;
  domains!: string[];
  domainLabels = Constants.TBA_DOMAIN_Lables;
  idMapping: any;

  constructor(
    private dialogRef: MatDialogRef<void>,
    public rootScope: RootScopeService,
    //public cusAccService: CustomerAccountBusinessLogicService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  
  ngOnInit(): void {
    this.getDomain();
  }

  closeDomainSelector() {
    this.dialogRef?.close();
  }

  getLabel(domain){
    if(domain?.includes(",")){
      let arr = domain?.split(",");
      const converted = arr.map(code =>  Constants.TBA_DOMAIN_Lables[code]);
      const result = converted.join(', ');
      return result;
    }
    else{
      return Constants.TBA_DOMAIN_Lables[domain];
    }
  }

 
  getDomain() {
    this.idMapping = this.rootScope?.activeCustTab?.tabData?.tabData?.idMapping;
    if (!this.idMapping) {
      console.error('idMapping is undefined or null');
      return;
    }

    const filteredMappings = this.idMapping.filter(mapping => mapping.platformType.includes('TBA'));
    const domains: any[] = [];
    for (const mapping of filteredMappings) {
      if (mapping?.domains) {
        // if (mapping.domains.includes(',')) {
        //   const splitDomains = mapping.domains.split(',');
        //   domains.push(...splitDomains);
        // } else {
          domains.push(mapping.domains);
        // }
      }
    }
     // Remove duplicate values
    this.domains = Array.from(new Set(domains));
    // this.domains = domains;

    
    console.log('domains', this.domains);
  }

  onSubmit() {
    console.log('domainSelection-onSubmit', this.selectedDomain);
    console.log('domainSelection-onSubmit', this.data);
    this.data.domain = this.selectedDomain;
    this.rootScope.selectedLeftNavBarLink(this.data, true);
    this.dialogRef?.close();
  }

}